import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../../Components/Layout";
import EmailSmsSetting from "../../../../Components/EventMgt/CreateEvent/Settings/EmailSms/EmailSmsSetting";
import useEventThunk from "../../../../Hooks/thunk/event";
import CreateEventFormTab from "../../../../Components/EventMgt/CreateEvent/CreateEventFormTab";
import EmailList from "../../../../Components/EventMgt/CreateEvent/Settings/EmailSms/EmailList";
import EmailTab from "../../../../Components/EventMgt/CreateEvent/Settings/EmailSms/EmailTab";
import SettingsTab from "../../../../Components/EventMgt/CreateEvent/Settings/SettingsTab";
import { EmailSmsLanguage } from "../../../../utils/SettingsLanguages";
import {
  EventById,
  deleteEmailSms,
  SendEmailTOAttendees,
  Stepper,
} from "../../../../utils/ApiConstant";
import MainComponentWrapper from "../../../../Components/Common/MainComponentWrapper";
import SubmitButtonGroup from "../../../../Components/UiElement/FormElement/SubmitBtnGroup";
const SettingEmailPage = () => {
  const { eventId } = useParams();
  const { EmailSmsForm, EmailSmsHeading } = EmailSmsLanguage;
  const [emailSms, setEmailSms] = useState();
  const eventData = useSelector((state) => state.event);
  const [selectedTab, setSelectedTab] = useState("EmailScheduled");
  const dispatch = useDispatch();
  const updEventDataWithFetch = useEventThunk();
  const navigate = useNavigate();
  useEffect(() => {
    if (!eventData.status) {
      dispatch(updEventDataWithFetch(EventById + eventId));
    }
  }, []);

  const handleTabClick = (TabDataId) => {
    setSelectedTab(TabDataId);
  };

  const HandleEditEmailSms = (emailSms) => {
    setEmailSms(emailSms);
    setSelectedTab("EmailScheduled");
  };

  const HandleDeleteEmailSms = async (emailSms) => {
    dispatch(
      updEventDataWithFetch(deleteEmailSms + eventId, {
        method: "delete",
        data: { _id: emailSms._id },
      })
    );
  };

  const handleSendEmail = async (emailSms) => {
    dispatch(
      updEventDataWithFetch(SendEmailTOAttendees + eventId, {
        method: "put",
        data: { _id: emailSms._id },
      })
    );
  };

  const handleStepper = async () => {
    dispatch(
      updEventDataWithFetch(Stepper + eventId, {
        method: "post",
      })
    );
  };

  return (
    <Layout
      BackAction="/organizer/MyEvents"
      Heading="Settings"
      TitleClassName="event-create-title"
      HeadClassName="event-page-head event-create-head"
      CreateHead
      activeMenuId="create-event"
      ExtraclassName="event-create-panel"
    >
      <MainComponentWrapper>
        <div className="eventCreationFrom">
          <CreateEventFormTab Id="settings" />

          <div className="evntFormUI event-settings-form">
            <SettingsTab Id="emailsms" />
            <section className="event-settings-section">
              <h2 className="event-settings-section-title is-accent">
                {EmailSmsHeading}
              </h2>
            </section>
            <EmailTab Id={selectedTab} ClickHandler={handleTabClick} />
            {selectedTab == "EmailScheduled" && (
              <EmailSmsSetting
                ClickHandler={handleTabClick}
                emailSmsData={emailSms}
              />
            )}
            {selectedTab != "EmailScheduled" && (
              <EmailList
                ListType={selectedTab}
                ClickHandler={HandleEditEmailSms}
                DeleteHandler={HandleDeleteEmailSms}
                sendEmail={handleSendEmail}
                Stepper={handleStepper}
              />
            )}
          </div>
        </div>
      </MainComponentWrapper>
    </Layout>
  );
};

export default SettingEmailPage;
